import React, { useState, useCallback, useEffect } from 'react'
import { navigate, useParams } from '@reach/router'
import { navigateToExpiredLink } from '_utils/expired-link-navigation'
import { useDispatch } from 'react-redux'

import { getNewServiceOrder } from '_modules/service-orders/actions'

import { Loader } from '@refera/ui-web'
import { ROUTES } from '_utils/constants'

// Component imports
import HeaderTitle from '_/components/header-title'
import EventHistory from './event-history'

const NewServiceOrderView = () => {
  const dispatch = useDispatch()
  const { serviceOrderId } = useParams()

  const title = `Chamado ${serviceOrderId}`
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false)

  const handleBackNavigation = useCallback(() => {
    return navigate(`${ROUTES.MANAGE_ORDERS}`)
  }, [navigate])

  useEffect(() => {
    dispatch(getNewServiceOrder(serviceOrderId)).catch(() => {
      navigateToExpiredLink()
    })
  }, [dispatch, serviceOrderId])

  return (
    <>
      <Loader open={isLoading} hasBackdrop />
      <HeaderTitle title={title} backButtonAction={handleBackNavigation} />
      <EventHistory />
    </>
  )
}

export default NewServiceOrderView
